export enum TextsTypes {
  TEXTS_REQUEST = 'appData/texts/TEXTS_REQUEST',
  TEXTS_SUCCESS = 'appData/texts/TEXTS_SUCCESS',
  TEXTS_FAILURE = 'appData/texts/TEXTS_FAILURE',
}
